/**
 * Created by DejanK on 3/17/2017.
 */
import angular from 'angular'
import rbFormValidation from './rb-form-validation/rb-form-validation.dir'
import rbShowFormErrorsOnHover from './rb-show-form-errors-on-hover/rb-show-form-errors-on-hover.dir' // @DEPRECATED use rbFormValidation
import rbMin from './rb-min/rb-min.dir';
import rbMinDyn from './rb-min/rb-min-dyn.dir'
import rbMax from './rb-max/rb-max.dir'
import rbMaxDyn from './rb-max/rb-max-dyn.dir'
import rbMatch from './rb-match/rb-match.dir'
import rbHasUppercase from './rb-has-uppercase/rb-has-uppercase.dir'
import rbHasLowercase from './rb-has-lowercase/rb-has-lowercase.dir'
import rbHasNumber from './rb-has-number/rb-has-number.dir'
import rbFileReader from './rb-file-reader.dir'
import rbUrlInputHelper from './rb-url-input-helper/rb-url-input-helper.dir'
import rbUrlValidator from './rb-url-validator/rb-url-validator.dir'

export default angular.module('rb.ui-form.directives', [])
  .directive('rbFormValidation', rbFormValidation)
  .directive('rbShowFormErrorsOnHover', rbShowFormErrorsOnHover) // @DEPRECATED use rbFormValidation
  .directive('rbMin', rbMin)
  .directive('rbMinDyn', rbMinDyn)
  .directive('rbMax', rbMax)
  .directive('rbMaxDyn', rbMaxDyn)
  .directive('rbMatch', rbMatch)
  .directive('rbHasUppercase', rbHasUppercase)
  .directive('rbHasLowercase', rbHasLowercase)
  .directive('rbHasNumber', rbHasNumber)
  .directive('rbFileReader', rbFileReader)
  .directive('rbUrlInputHelper', rbUrlInputHelper)
  .directive('rbUrlValidator', rbUrlValidator)
